import { formatDate } from '@angular/common';
import {
	HttpClient,
	HttpErrorResponse,
	HttpResponse
} from '@angular/common/http';
import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { UserService } from '@app/core/auth';
import { LoadingService } from '@app/theme/layouts/loading.services';
import { ApiClient } from '@eng-ds/api-client';
import { I18nService } from '@eng-ds/translate';
import { NbToastrService } from '@nebular/theme';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class FileDownloadService {
	/**
	 * DI
	 */
	public locale = inject(LOCALE_ID);
	private apiClient = inject(ApiClient);
	private httpClient = inject(HttpClient);
	private i18n = inject(I18nService);
	private loading = inject(LoadingService);
	private toastrService = inject(NbToastrService);
	private userService = inject(UserService);

	downloadFiles_FLUS_234(
		type: string,
		fileIds: string[],
		nameDefault: string
	) {
		this.loading.show();
		const fileFormat = this.getFormat(type);
		const __body = {
			IdFlussi: fileIds,
			Formato: fileFormat,
			MarkDownloaded: true,
			FileNameZip: this.getDateString() + nameDefault + '_' + type
		};
		const url = this.apiClient.getUrlByApiName('get' + type);

		this.httpClient
			.request('POST', url, {
				//  params,
				body: __body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	downloadAmmissibilita_FLUS_5(
		id: string,
		type: string,
		nameDefault: string
	) {
		this.loading.show();
		const fileFormat = this.getFormat(type);
		const __body = {
			IdFile: id,
			Formato: fileFormat,
			MarkDownloaded: true,
			FileNameZip: this.getDateString() + nameDefault + '_' + type
		};
		const url = this.apiClient.getUrlByApiName('FLUS_5');

		this.httpClient
			.request('POST', url, {
				//  params,
				body: __body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	downloadDocumentale_DOC_1(
		tickets: string[],
		fileName: string,
		CompressZIP = true
	) {
		const body = {
			Ticket: tickets,
			CompressZIP,
			FileNameZIP: this.getDateString() + fileName,
			...this.getSpecIdUdd()
		};
		const urlApi = this.apiClient.getUrlByApiName('DOC_1');

		this.httpClient
			.request('POST', urlApi, {
				//  params,
				body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	downloadFileLog_RIC_7b(idFile: string) {
		this.loading.show();
		const body = {
			IdFile: idFile
		};
		const urlApi = this.apiClient.getUrlByApiName('RIC_7b');

		return this.httpClient
			.request('POST', urlApi, {
				body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError(async (err: HttpErrorResponse) => {
					this._handleErrorFileLog(err);
				})
			)
			.subscribe();
	}

	private async _handleErrorFileLog(err: HttpErrorResponse) {
		try {
			this.loading.hide();
			const { Body } = JSON.parse(await (err.error as Blob)?.text());
			this.toastrService.success(
				Body.Descrizione,
				this.i18n.translate('UPLOADS.NO_FILE_LOG_TOASTR.TITLE')
			);
		} catch (err) {
			return this.catchErrorFunction(err);
		}
	}

	downloadOriginale_RIC_10(idFile: string, idFlusso: string) {
		this.loading.show();
		const body = {
			IdFile: idFile,
			IdFlusso: idFlusso
		};
		const urlApi = this.apiClient.getUrlByApiName('RIC_10');

		return this.httpClient
			.request('POST', urlApi, {
				body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	downloadFlusso_RIC_11(id: string, type: string, ambito: string) {
		this.loading.show();
		const body = {
			IdFlusso: id,
			MarkDownloaded: true,
			AmbitoPortale: ambito,
			FormatoFile: type.toUpperCase()
		};
		const urlApi = this.apiClient.getUrlByApiName('RIC_11');

		this.httpClient
			.request('POST', urlApi, {
				body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	downloadAutoletture_AUTOL_5(id: string, nameDefault: string) {
		this.loading.show();
		// const fileFormat = this.getFormat(type);
		const __body = {
			IdFile: id,
			// FormatoFile: type,
			NomeFile: this.getDateString() + nameDefault,
			...this.getSpecIdUdd()
		};
		const url = this.apiClient.getUrlByApiName('AUTOL_5');

		this.httpClient
			.request('POST', url, {
				//  params,
				body: __body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	downloadAnagrafica_COM_4(tickets: string[], fileName: string) {
		this.loading.show();
		const body = {
			Ticket: tickets,
			CompressZIP: false,
			FileNameZIP: this.getDateString() + fileName
			// ...this.getSpecIdUdd()
		};
		const urlApi = this.apiClient.getUrlByApiName('COM_4');

		this.httpClient
			.request('POST', urlApi, {
				//  params,
				body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	getAnagrafica_PDR_11(IdPdR: string) {
		const body = {
			IdPdR: IdPdR,
			...this.getSpecIdUdd()
		};

		const urlApi = this.apiClient.getUrlByApiName('PDR_11');

		this.httpClient
			.request('POST', urlApi, {
				//  params,
				body,
				observe: 'response',
				responseType: 'blob'
			})
			.pipe(
				tap((res: HttpResponse<Blob>) => {
					this.downloadMethod(res);
				}),
				catchError((err: HttpErrorResponse) => {
					return this.catchErrorFunction(err);
				})
			)
			.subscribe();
	}

	private getSpecIdUdd() {
		if (this.userService.isSuperRole) {
			return { IdUdd: this.userService.user.PartitaIvaUdD };
		} else {
			return {};
		}
	}

	private downloadMethod(res: HttpResponse<Blob>) {
		this.loading.hide();
		const blob = res.body;
		let fileName = null;
		const contentType = res.headers.get('content-type');
		// c'è un errore nella gestione della chiamata lato server
		// perchè questo caso non dovrebbe essere un blob
		if (contentType.indexOf('application/json') > -1) {
			throwError(new Error('The server response is application/json'));
		}
		// IE/EDGE seems not returning some response header
		// eslint-disable-next-line
		if (res.headers.get('content-disposition')) {
			const contentDisposition = res.headers.get('content-disposition');
			fileName = contentDisposition
				.substring(contentDisposition.indexOf('=') + 1)
				.replace(/['"]+/g, '');
		} else {
			fileName =
				'unnamed.' +
				contentType.substring(contentType.indexOf('/') + 1);
		}
		const nav: any = window.navigator;
		if (nav.msSaveOrOpenBlob) {
			// Internet Explorer
			nav.msSaveOrOpenBlob(
				new Blob([blob], { type: contentType }),
				fileName
			);
		} else {
			const el: any = document.createElement('a');
			el.href = window.URL.createObjectURL(blob);
			el.download = fileName;
			el.click();
		}
	}

	private catchErrorFunction(err: HttpErrorResponse) {
		this.loading.hide();
		this.toastrService.danger(
			this.i18n.translate(
				'REQUESTS.PUNCTUAL_LOADING.ERRORS.DOWNLOAD_FILE.MESSAGE'
			),
			this.i18n.translate(
				'REQUESTS.PUNCTUAL_LOADING.ERRORS.DOWNLOAD_FILE.TITLE'
			)
		);
		return throwError(() => err);
	}

	private getFormat(format: string): number {
		switch (format.toUpperCase()) {
			case 'XML':
				return 0;
			case 'CSV':
				return 1;
			case 'XLSX':
				return 2;
		}
	}

	private getDateString() {
		return formatDate(new Date(), 'yyyyMMddHHmmss', this.locale) + '_';
	}
}
